import React from 'react';
import AppLogo512 from '../../../BMG-512.png';
import useGoHome from '../useGoHome';
import { windowSize } from '../utils';
import { APP_URL } from '../config';

const BmgButton = () => {
  const goHome = useGoHome();
  const logo = () => <img src={AppLogo512} width={width * 0.75} alt="BMG logo" />;

  const { x: wx, y: wy } = windowSize();
  const width = Math.min(wx, wy) / 7;

  return (
    <div
      style={{ position: 'absolute', height: `${width * 0.75}px`, top: `${width * 0.25}px`, right: `${width * 0.25}px`, cursor: 'pointer' }}
      onClick={goHome}>
      {APP_URL ? <a href={APP_URL}>{logo()}</a> : logo()}
    </div>
  );
};

export default BmgButton;
